import { parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';

/**
 * Extracts the calling code and user's number from a phone number string
 * @param phoneNumber - The phone number to parse
 * @returns Object containing calling code and user's number
 */
export const extractCallingCodeAndNumber = (
    phoneNumber: string
): { callingCode: string; usersNumber: string } => {
    if (!phoneNumber) {
        return { callingCode: '', usersNumber: '' };
    }

    // Ensure the phone number starts with '+' for proper parsing
    const sanitizedNumber = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;

    const parsedNumber: PhoneNumber = parsePhoneNumberFromString(sanitizedNumber);

    if (!parsedNumber?.isValid()) {
        return { callingCode: '', usersNumber: '' };
    }

    return {
        callingCode: parsedNumber.countryCallingCode,
        usersNumber: parsedNumber.nationalNumber,
    };
};

export default extractCallingCodeAndNumber;
